module.exports = __webpack_public_path__ + "img/visitasperfil.d3add6f6.svg";